import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M11.8 4.2l6.6 3.1-2.6 5.5m-10.3 5l3.6 1.7m-3.6-1.7v4.7l3.6-3 7.5-16c.2-.3 0-.7-.3-.9l-2.4-1.1c-.3-.2-.7 0-.9.3l-7.5 16z" stroke="currentColor" fill="none" /></svg>;